<template>
  <div class="container">
    <div id="header" class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="销售单号">
            <el-input style="width:200px" v-model="formInline.platformOrderId" placeholder="销售单号/交易号" clearable />
          </el-form-item>
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.mater" placeholder="产品SKU,名称" clearable />
          </el-form-item>
          <el-form-item label="物流单号">
            <el-input style="width:200px" v-model="formInline.trackNumber" placeholder="物流单号" clearable />
          </el-form-item>
          <el-form-item label="物流到货时间">
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.startMonth"
                type="date"
                placeholder="请选择物流到货时间"
                clearable
                @clear="formInline.startMonth=''"
            />
            -
            <el-date-picker
                value-format="YYYY-MM-DD"
                format="YYYY-MM-DD"
                v-model="formInline.endMonth"
                type="date"
                placeholder="请选择物流到货时间"
                clearable
                @clear="formInline.endMonth=''"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
<!--            <el-button type="success" style="margin-left: 12px;" @click="handleExport">导出</el-button>-->
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="dynamicHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
        >
          <el-table-column
              label="来源分类"
              min-width="120"
              prop="receiveSaleType"
          >
            <template #default="scope">

                <div v-if="scope.row.receiveSaleType==1" >个人退货</div>
                <div v-if="scope.row.receiveSaleType==2" >平台退货</div>
            </template>
          </el-table-column>
          <el-table-column
              label="订单号/平台交易号"
              min-width="120"
              prop="receiveSaleNumber"
          ></el-table-column>
          <el-table-column
              label="产品SKU"
              min-width="100"
              prop="receiveMaterSku"
          ></el-table-column>
          <el-table-column
              label="产品名称"
              min-width="100"
              prop="receiveMaterName"
          ></el-table-column>
          <el-table-column
              label="数量"
              min-width="80"
              prop="quantity"
          >
          </el-table-column>
          <el-table-column
              label="退货物流单号"
              min-width="100"
              prop="receiveNumber"
          >
          </el-table-column>
          <el-table-column
              label="核实备注"
              min-width="120"
          >
            <template #default="scope">
              <div v-if="scope.row.reasonCN" >分类：{{scope.row.reasonCN}}</div>
              <el-tooltip
                  v-if=" scope.row.remarks && scope.row.remarks.length>20"
                  class=""
                  effect="dark"
                  :content="scope.row.remarks"
              >
                <span class="ellipsis-3-lines" >详细原因：{{scope.row.remarks}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>

  </div>
</template>
<script>
import {
  ElForm, ElFormItem, ElButton, ElInput, ElDatePicker, ElTable,

  ElTableColumn, ElPagination
} from "element-plus";
import {toDoListPc} from "@/utils/api";
import {baseUrl}  from "../../../src/utils/requset.js";
import DynamicHeightMixin from "../../../public/js/dynamicHeightMixin";
import {getLocalStockList} from "../../../public/js";


export default {
  name: "toDoList",
  mixins:[DynamicHeightMixin],
  components: {ElForm,ElFormItem,ElButton,ElInput,ElDatePicker,ElTable,
    ElTableColumn,ElPagination},
  data(){
    return{
      formInline:{
        status:"1"
      },
      stockList:[],
      tableData:[],
      resiveList:[
        {label:"未签收",value:1},
        {label:"已签收",value:2}
      ],
      currentPage:1,
      pageTotal:0,
      pageSize:20,
      confirmDialogVisible: false,
      currentData: null
    }
  },
  beforeMount() {
    this.getReceipt();
    this.getLocalStockList()
  },
  mounted() {
    this.formInline.status = 1;
  },
  methods:{
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    onSubmit(){
      this.PageNumber = 1
      this.getReceipt()
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getReceipt();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getReceipt();
    },
    getReceipt(){
      toDoListPc({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage}).then(res=>{
        this.tableData = res.Data
        this.pageTotal = res.Total
      }).catch(res=>{
        console.log(res)
      })
    },
    handleClick(data){
      this.$refs.addInStore.open(data)
    },
    handle(data){
      this.$refs.addInStoreTrack.open(data)
    },
    check(data){
      this.$refs.arehouseAndQuality.open(data)
    },
    close(){
      this.getReceipt()
    },
    // 导出功能，参考 operationLog.vue 的导出逻辑
    handleExport() {
      // 将表单参数编码后附加到URL上
      let pramas = Object.entries(this.formInline)
          .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
          .join('&');
      // 假设导出接口为 export_tempInStore
      let url = baseUrl + 'after/outListPcExport?'+ pramas;
      
      // 打开新窗口导出
      window.open(url);
    },
  }
}
</script>
<style scoped>
.container{
  width: 92%;
  margin:0 auto;
}
::v-deep .container {
  .el-form-item{
    margin-bottom:0!important;
  }
}
::v-deep .el-table .el-table__cell{
  box-sizing: border-box;
  min-width: 0;
  padding: 8px 0;
  position: relative;
  text-align: left;
  text-overflow: ellipsis;
  vertical-align: middle;
  z-index: unset !important;
}
.edit-cell {
  padding: 0 8px;
}
.edit-cell .el-input {
  margin: 0;
}
.edit-cell .el-input__wrapper {
  padding: 0 8px;
  box-shadow: none;
  border-color: #dcdfe6;
}
.edit-cell .el-input__wrapper:focus-within {
  box-shadow: 0 0 0 1px #409eff inset;
  border-color: #409eff;
}
.remark-cell {
  display: inline-block;
  padding: 2px 8px;
  cursor: pointer;
  min-height: 20px;
  min-width: 20px;
}
.remark-cell:hover {
  background-color: #f5f7fa;
  border-radius: 3px;
}
/* 无值备注的样式 */
.empty-remark {
  border: 1px dashed #dcdfe6;
  background-color: #f8f9fa;
  padding: 2px 8px;
  border-radius: 3px;
  color: inherit;
}
.empty-remark:hover {
  border-color: #409eff;
  background-color: #ecf5ff;
}

/* 占位符文本样式 */
.placeholder-text {
  color: #909399;
}
.empty-remark:hover .placeholder-text {
  color: #409eff;
}
::v-deep .el-button+.el-button {
  margin-left: 0px;
}


</style>